/**
 * Shared helpers for cart line-property retag scripts.
 * Suppresses Swish "saved from cart" toasts while programmatic /cart/change
 * updates run (Shopify line-key changes look like removals to Swish).
 */
window.VbysCartRetag = window.VbysCartRetag || {
  _suppressCount: 0,
  _previewApplied: false,

  withSwishCartSaveSuppressed(callback) {
    this._suppressCount += 1;

    if (this._suppressCount === 1) {
      document.documentElement.dataset.vbysSuppressSwishCartSave = 'true';

      const swish = window.swish;
      if (swish?.intents?.applyPreview) {
        swish.intents.applyPreview({
          removeCartLine: { saveCartLine: false },
          saveCartLine: { showFeedback: false },
        });
        this._previewApplied = true;
      }
    }

    return Promise.resolve(callback()).finally(() => {
      this._suppressCount -= 1;

      if (this._suppressCount > 0) return;

      delete document.documentElement.dataset.vbysSuppressSwishCartSave;

      if (this._previewApplied) {
        const swish = window.swish;
        const defaultIntents = window.SwishOptions?.intents;

        if (swish?.intents?.applyPreview && defaultIntents) {
          swish.intents.applyPreview({
            removeCartLine: defaultIntents.removeCartLine,
            saveCartLine: defaultIntents.saveCartLine,
          });
        }

        this._previewApplied = false;
      }
    });
  },
};
